<template>
  <div>
    <!-- Filters -->
    <b-card no-body>
      <b-card-header class="pb-50">
        <h5>Filter Location</h5>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <b-form-group label-for="bank_id" label="Pay Bank" style="cursor: pointer">
              <validation-provider #default="{ errors }" name="bank_id" rules="">
                <b-form-select size="sm" id="bank_id" name="bank_id" v-model="bank_id"
                               :state="errors.length > 0 ? false : null" @change="filterSales">
                  <b-form-select-option :value="null">Select...</b-form-select-option>
                  <b-form-select-option v-for="bank in banks" :key="bank.id" :value="bank.id">{{
                    bank.name }}</b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-danger" v-if="serverErrors && serverErrors.bank_id">{{
                  serverErrors.bank_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="1" class="mb-md-0 mb-2">
            <b-form-group label-for="currency_id" label="Currency" style="cursor: pointer">
              <validation-provider #default="{ errors }" name="currency_id" rules="">
                <b-form-select size="sm" id="currency_id" name="currency_id" v-model="currency_id"
                               :state="errors.length > 0 ? false : null" @change="filterSales">
                  <b-form-select-option :value="null">Select...</b-form-select-option>
                  <b-form-select-option v-for="currency in currencies" :key="currency.id"
                                        :value="currency.id">{{ currency.abbreviation }}</b-form-select-option>
                </b-form-select>
                <small class="text-danger">{{ errors[0] }}</small>
                <small class="text-danger" v-if="serverErrors && serverErrors.currency_id">{{
                  serverErrors.currency_id[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col cols="12" md="6" class="mb-md-0 mb-2">
            <b-row>
              <b-col cols="12" md="12" class="mb-md-0 mb-2">
                <location-filters size="sm" align="horizontal" @filter="changeFilter" />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
    <!-- ./Filters -->

    <b-modal
      id="modal-danger"
      ok-variant="danger"
      ok-title="Confirm"
      cancel-title="Cancel"
      modal-class="modal-danger"
      centered
      size="xl"
      title="Payment List"
      button-size="sm"
      @ok="initiatePayments()"
    >
        <b-card-body>
            <b-row>
                <b-col cols="12" md="12">
                    <b-table
                        striped
                        hover
                        small
                        ref="records"
                        class="position-relative"
                        :items="selecteds"
                        responsive
                        :fields="modalColumns"
                        primary-key="sale_id"
                        show-empty
                        empty-text="No records found"
                    >
                        <template #cell(market)="data">
                            <span v-if="data.item.market.code !== null">{{ data.item.market.code.toUpperCase() }}: {{ data.item.market.name.toUpperCase() }}</span>
                            <span v-else>{{ data.item.market.name.toUpperCase() }}</span>
                        </template>

                        <template #cell(account_name)="data">
                            {{ data.item.account.name }}
                        </template>

                        <template #cell(account_number)="data">
                            {{ data.item.account.number }}
                        </template>

                        <template #cell(currency)="data">
                            {{ data.item.account.abbreviation }}
                        </template>

                        <template #cell(value)="data">
                            {{ data.item.value.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                        </template>

                        <template #cell(deductions)="data">
                            {{ data.item.deduction.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                        </template>

                        <template #cell(net)="data">
                            {{ (data.item.value - data.item.deduction).toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
                        </template>
                    </b-table>
                </b-col>
            </b-row>
        </b-card-body>
    </b-modal>

    <!-- Table Container Card -->
    <b-card no-body class="mb-0">
        <div class="m-2">
            <!-- Table Top -->
            <b-row>
                <!-- Search & Button -->
                <b-col cols="12" md="12">
                    <div class="d-flex align-items-center justify-content-end">
                        <b-button
                            :variant="selecteds.length > 0? 'outline-danger' : 'outline-secondary'"
                            size="sm"
                            :disabled="selecteds.length === 0"
                            v-b-modal.modal-danger
                        >
                            <span class="align-middle">Initiate Pay</span>
                            <feather-icon
                                icon="SunriseIcon"
                                class="ml-50"
                            />
                        </b-button>
                    </div>
                </b-col>
                <!-- ./Search & Button-->
            </b-row>
            <!-- ./Table Top -->
        </div>

        <!-- Table -->
        <b-table
            striped
            hover
            small
            ref="records"
            class="position-relative"
            :items="payables"
            responsive
            :fields="columns"
            primary-key="sale_id"
            show-empty
            empty-text="No records found"
        >
            <template #cell(id)="data">
                <b-form-checkbox
                    :value="data.item"
                    v-model="selecteds"
                    class="custom-control-danger"
                />
            </template>

            <template #cell(market)="data">
                <span v-if="data.item.market.code !== null">{{ data.item.market.code.toUpperCase() }}: {{ data.item.market.name.toUpperCase() }}</span>
                <span v-else>{{ data.item.market.name.toUpperCase() }}</span>
            </template>

            <template #cell(account_name)="data">
                {{ data.item.account.name }}
            </template>

            <template #cell(account_number)="data">
                {{ data.item.account.number }}
            </template>

            <template #cell(currency)="data">
                {{ data.item.account.abbreviation }}
            </template>

            <template #cell(value)="data">
                {{ data.item.value.toLocaleString('en-US', { style: 'currency', currency: data.item.account.abbreviation, minimumFractionDigits: 3, maximumFractionDigits: 3 }) }}
            </template>
        </b-table>
    </b-card>
    <!-- ./Table Container Card -->
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import {
    BCard, BCardHeader, BCardBody, BCardText,
    BRow, BCol,
    BForm, BFormGroup, BFormInput, BFormCheckbox, BDropdown, BDropdownItem,
    BButton, BSpinner, BFormSelect, BFormSelectOption,
    BTable, BPagination, BBadge, BAvatar,
    VBModal
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { required } from '@validations'
import store from '@/store'
import { ref, onUnmounted, onMounted, computed } from '@vue/composition-api'
import paymentsStoreModule from '@/views/cromis/payments/payment/paymentsStoreModule'
import LocationFilters from '@core/components/cromis/filters/LocationFilters.vue'
import { number } from 'echarts/lib/export'

export default {
    props: {},
    components: {
        BCard, BCardHeader, BCardBody, BCardText,
        BRow, BCol,
        BForm, BFormGroup, BFormInput, BFormCheckbox, BDropdown, BDropdownItem, vSelect,
        BButton, BSpinner, BFormSelect, BFormSelectOption,
        BTable, BPagination, BBadge, BAvatar,
        ValidationProvider, ValidationObserver, VBModal,
        LocationFilters,
    },
    directives: {
        'b-modal': VBModal,
    },
    setup(props, context) {
        const dataForm = ref(null)
        const saving = ref(false)
        const serverErrors = ref(null)

        const banks = ref([])
        const currencies = ref([])
        const location_id = ref(null)
        const bank_id = ref(null)
        const currency_id = ref(null)
        const payables = ref([])
        const selecteds = ref([])

        const columns = ref([
            { key: 'id', label: '', sortable: false },
            { key: 'name', label: 'Society Name', sortable: false },
            { key: 'code', sortable: false },
            { key: 'market', label: 'Market Center', sortable: false },
            { key: 'saleNumber', label: 'Sale #', sortable: false },
            { key: 'closedDate', label: 'Closed Date', sortable: false },
            { key: 'account_name', sortable: false },
            { key: 'account_number', sortable: false },
            { key: 'currency', sortable: false },
            { key: 'value', sortable: false, thStyle: { width: "15%" }, thClass: 'text-right', tdClass: 'text-right'},
        ])

        const modalColumns = ref([
            { key: 'name', label: 'Society Name', sortable: false, thStyle: { width: "25%" } },
            { key: 'code', sortable: false },
            { key: 'market', label: 'Market Center', sortable: false, thStyle: { width: "25%" } },
            { key: 'saleNumber', label: 'Sale #', sortable: false },
            { key: 'account_number', label: 'Account', sortable: false },
            { key: 'value', sortable: false, thStyle: { width: "12%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'deductions', sortable: false, thStyle: { width: "10%" }, thClass: 'text-right', tdClass: 'text-right'},
            { key: 'net', label: 'Net', sortable: false, thStyle: { width: "10%" }, thClass: 'text-right', tdClass: 'text-right'},
        ])

        const CROMIS_GROUP_STORE_MODULE_NAME = 'cromis-payments'

        // Register module
        if (!store.hasModule(CROMIS_GROUP_STORE_MODULE_NAME)) store.registerModule(CROMIS_GROUP_STORE_MODULE_NAME, paymentsStoreModule)

        // UnRegister on leave
        onUnmounted(() => {
            if (store.hasModule(CROMIS_GROUP_STORE_MODULE_NAME)) store.unregisterModule(CROMIS_GROUP_STORE_MODULE_NAME)
        })

        onMounted(async () => {
            await store.dispatch('cromis-payments/getBanks')
                .then(response => {
                    banks.value = response.data.banks
                })
                .catch(error => {
                    console.log(error)
                })

            await store.dispatch('cromis-payments/getCurrencies')
                .then(response => {
                    currencies.value = response.data.currencies
                })
                .catch(error => {
                    console.log(error)
                })
        })

        const changeFilter = (filteredLocation) => {
            location_id.value = filteredLocation !== null ? filteredLocation.id : null
            filterSales()
        }

        const filterSales = async () => {
            if (bank_id.value !== null && currency_id.value !== null && location_id.value !== null) {
                await store.dispatch('cromis-payments/getSales', { bank_id: bank_id.value, location_id: location_id.value, currency_id: currency_id.value })
                    .then(response => {
                        payables.value = response.data.payables

                        payables.value = payables.value.flatMap(payable => {
                            return payable.sales.map(sale => {
                                return {
                                    id: payable.id,
                                    type: 1,
                                    code: payable.code,
                                    number: payable.number,
                                    name: payable.name,
                                    sale_id: sale.id,
                                    saleNumber: sale.number,
                                    market: sale.market,
                                    closedDate: sale.closedDate,
                                    account: payable.account,
                                    value: sale.value,
                                    deduction: sale.ticketsDeductions,
                                }
                            })
                        })
                    })
                    .catch(error => {
                        console.log(error)
                    })
            }
        }

        const initiatePayments = async () => {
            for(let i = 0; i < selecteds.value.length; i++){
                await store.dispatch('cromis-payments/create', {
                    credited_type: 1,
                    beneficiary_id: selecteds.value[i].id,
                    payment_type: 1,
                    payable_id: selecteds.value[i].sale_id,
                    account_id: selecteds.value[i].account.id,
                    amount: selecteds.value[i].value,
                    deduction: selecteds.value[i].deduction,
                })
                .then(response => {
                    // console.log(response)
                })
                .catch(error => {
                    if(error.response.status === 422){
                      serverErrors.value = error.response.data.errors
                  }
                  else{
                      context.root.$swal({
                          icon: 'error',
                          title: 'Server Error',
                          text: 'Something went wrong. See tech support',
                          showConfirmButton: true,
                          customClass: {
                              confirmButton: 'btn btn-danger',
                          },
                          buttonsStyling: false,
                      })
                  }
                })
            }

            context.root.$swal({
                icon: 'success',
                text: `Payments to all ${selecteds.value.length} beneficiaries have been initiated successfully!`,
                showConfirmButton: true,
                timer: 5000,
                customClass: {
                    confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
            })

            selecteds.value = []

            filterSales()
        }

        return {
            // Form
            dataForm,
            saving,
            serverErrors,
            changeFilter,
            filterSales,

            // Validations
            required,
            banks,
            currencies,
            selecteds,
            bank_id,
            currency_id,
            payables,

            // Table
            columns,
            modalColumns,
            initiatePayments,
        }
    }
}
</script>

<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
</style>
